import { render, staticRenderFns } from "./lista-buscador-seleccion-estado.vue?vue&type=template&id=5713b1cf&scoped=true&"
import script from "./lista-buscador-seleccion-estado.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador-seleccion-estado.vue?vue&type=script&lang=ts&"
import style0 from "./lista-buscador-seleccion-estado.vue?vue&type=style&index=0&id=5713b1cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5713b1cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
